import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import type Link from 'ember-link/link';
import { or } from 'ember-truth-helpers';
import Pillbox from 'garaje/components/ui/classic/pillbox';

interface TabItemSignature {
  Args: {
    link?: Link;
    isActive?: boolean;
    isNew?: boolean;
    class?: string;
  };
  Element: HTMLElement;
  Blocks: {
    default: [];
  };
}

export default <template>
  {{#if @link}}
    <a
      data-test-tab-item
      href={{@link.url}}
      aria-current={{if (or @link.isActiveWithoutQueryParams @isActive) "page"}}
      class="text-sm py-2 inline-block
        {{if @isNew 'mr-1' 'mr-4'}}
        {{if (or @link.isActiveWithoutQueryParams @isActive) 'active'}}"
      {{on "click" @link.transitionTo}}
      ...attributes
    >
      {{yield}}
    </a>
  {{else}}
    <span data-test-tab-item class="text-sm py-2 inline-block {{if @isNew 'mr-1' 'mr-4'}}" ...attributes>
      {{yield}}
    </span>
  {{/if}}
  {{#if @isNew}}
    <Pillbox class="mr-4 -translate-y-[2px] tracking-[0.636px]" @color="gem" @size="sm">
      NEW
    </Pillbox>
  {{/if}}
</template> satisfies TOC<TabItemSignature>;
